import React from "react";

export default function OverviewIcon(props?: any) {
  const svgStyles: any = {
    width: props.width ? props.width : null,
    height: props.height ? props.height : null,
    fill: props.fill ? props.fill : null,
    margin: props.margin ? props.margin : null,
  };

  const filteredStyles = Object.keys(svgStyles)
    .filter((key) => svgStyles[key] !== null && svgStyles[key] !== undefined)
    .reduce((acc: any, key) => {
      acc[key] = svgStyles[key];
      return acc;
    }, {});

  return (
    <svg viewBox="0 0 14 14" fill="none" style={{ ...filteredStyles, fill: "none" }} className={props.className} xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1481_3415)">
        <g clipPath="url(#clip1_1481_3415)">
          <path
            d="M13.2222 12.6311L11.0678 10.4766C12.0663 9.32496 12.5789 7.8307 12.4977 6.30857C12.4165 4.78644 11.7477 3.35524 10.6322 2.31639C9.51674 1.27754 8.04165 0.71212 6.51759 0.739212C4.99354 0.766304 3.53947 1.38379 2.46163 2.46163C1.38379 3.53947 0.766304 4.99354 0.739212 6.51759C0.71212 8.04165 1.27754 9.51674 2.31639 10.6322C3.35524 11.7477 4.78644 12.4165 6.30857 12.4977C7.8307 12.5789 9.32496 12.0663 10.4766 11.0678L12.6311 13.2222L13.2222 12.6311ZM1.61386 6.6422C1.6131 5.64752 1.90735 4.67496 2.4594 3.84755C3.01145 3.02013 3.7965 2.37503 4.71524 1.99385C5.63398 1.61267 6.64513 1.51254 7.62079 1.70612C8.59645 1.8997 9.49277 2.3783 10.1964 3.08137C10.9 3.78444 11.3793 4.68039 11.5736 5.6559C11.768 6.63141 11.6686 7.64264 11.2881 8.56167C10.9077 9.4807 10.2632 10.2663 9.43619 10.8189C8.6092 11.3716 7.63687 11.6666 6.6422 11.6666C5.30959 11.6656 4.0318 11.136 3.08914 10.1941C2.14648 9.25218 1.61592 7.9748 1.61386 6.6422Z"
            fill={filteredStyles.fill}
          />
          <path d="M4.12988 5.38623H9.15822V6.22234H4.12988V5.38623Z" fill={filteredStyles.fill} />
          <path d="M4.12988 7.06226H6.64211V7.89837H4.12988V7.06226Z" fill={filteredStyles.fill} />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1481_3415">
          <rect width="14" height="14" fill="white" />
        </clipPath>
        <clipPath id="clip1_1481_3415">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
